import React from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

interface ConnectionCellProps {
  status: string;
  last_connect?: string;
}

enum ConnectionIcon {
  dark = 'ri-wifi-off-fill',
  success = 'ri-wifi-fill',
}

const ConnectionCell: React.FC<ConnectionCellProps> = ({ status, last_connect }) => {
  const { t } = useTranslation();
  const iconClass = ConnectionIcon[status as keyof typeof ConnectionIcon] || '';

  const isConnectionOld = last_connect ? dayjs().diff(dayjs(last_connect), 'minute') > 75 : false;

  return (
    <div>
      <button
        title={status === 'dark' ? t('TrapTables.noRecentHeartbeat') : t('TrapTables.heartbeatReceived')}
        type="button"
        className={`btn btn-sm btn-ghost-${status} btn-rounded custom-toggle active ${isConnectionOld ? 'border border-success' : ''}`}
        data-bs-toggle="button"
        style={{ borderRadius: '50%' }}
      >
        <span className="icon-on fs-6">
          <i className={iconClass} />
        </span>
        <span className="icon-off fs-6">
          <i className={iconClass} />
        </span>
      </button>
    </div>
  );
};

export default ConnectionCell;
